<button class="close-button" (click)="onClose()" [title]="title()">
  <span class="material-icons">close</span>
</button>
